import React from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { fetchGet } from "../../../api/fetch";

import ProfileMatchExpress from "../../SiteEntranceExit/CorrectConfirmValue/ProfileMatchExpress";
import { isUnknownProfile } from "../../../utils/profile";
import ProfileMatchExpressUnknown from "../../SiteEntranceExit/CorrectConfirmValue/ProfileMatchExpressUnknown";

const SchedulerOccurrenceProfile = (props) => {
  const { language, profileId } = props;
  const [profile, setProfile] = React.useState();

  React.useEffect(() => {
    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileId]);

  const fetchProfile = async () => {
    if (profileId) {
      try {
        setProfile(await fetchGet(`profiles/${profileId}`));
      } catch (e) {
        console.log(e);
      }
    }
  };

  if (isUnknownProfile(profileId)) {
    return (
      <ProfileMatchExpressUnknown
        type={1}
        style={{ padding: 0, margin: "2px 0px", ...props.style }}
      />
    );
  }

  return (
    <ProfileMatchExpress
      profile={profile}
      language={language}
      style={{ padding: 0, margin: "2px 0px", ...props.style }}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default connect(mapStateToProps)(SchedulerOccurrenceProfile);
